<template>
  <div class="filterOutBox">
  <Form inline label-position="top" ref="tableFilterForm" :model="filter" class="filterFormBox" :class="!buttonStatus ? 'filterFormHide' : 'filterFormShow'">
    <Row :gutter="16" v-for="(row, index) in fields" :key="index" >
      <Col :xs="24" :sm="12" :md="item.span" v-for="(item, indexKey) in row" :key="indexKey" >
        <FormItem :label="item.label + '：'" v-if="item.type=='input'" :prop="item.model">
          <Input v-model.trim="filter[item.model]" :placeholder="item.placeholder ? item.placeholder : '请填写' + item.label" >
            <span slot="append" v-if="item.suffix">{{item.suffix ? item.suffix: ''}}</span>
          </Input>
        </FormItem>
        <FormItem :label="item.label + '：'" v-if="item.type=='textarea'" :prop="item.model" >
          <Input v-model.trim="filter[item.model]" type="textarea" :maxlength="800" :placeholder="item.placeholder ? item.placeholder : '请填写' + item.label"></Input>
        </FormItem>
        <FormItem :label="item.label + '：'" v-if="item.type=='select'" :prop="item.model" >
            <select class="filterSelect" v-model="filter[item.model]" :transfer=true
                    @change="item.fun && runMethods(item.fun, item.params)" :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label">
              <option v-for="(opt, index) in item.options" :value="opt.value" :key="index">{{ opt.name }}</option>
            </select>
        </FormItem>
        <FormItem :label="item.label + '：'" v-if="item.type=='selectNormal'" :prop="item.model" >
              <Select class="billUserSelect" v-model="filter[item.model]" :transfer="true" :filterable="item.filterable"
                @on-change="val => selectNormalChange(val, item.fun, item.params)" :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label">
                <Option v-for="(opt, index) in item.options" :value="opt.value" :key="index">{{ opt.name }}</option>
              </Select>
          </FormItem>
        <FormItem :label="item.label + '：'" v-if="item.type=='date'" :prop="item.model">
          <Date-picker type="date" :format="item.format || 'yyyy-MM-dd'" :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label" class="selectW" v-model="filter[item.model]" @on-change="filter[item.model] = $event"></Date-picker>
        </FormItem>
        <FormItem :label="item.label + '：'" v-if="item.type=='daterange'" :prop="item.model">
          <Date-picker type="daterange" :format="item.format || 'yyyy-MM-dd'" :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label" class="selectW" v-model="filter[item.model]" @on-change="filter[item.model] = $event"></Date-picker>
        </FormItem>
        <FormItem :prop="item.model" :label="item.label + ':'" v-if="item.type == 'month'" >
          <DatePicker format="yyyy-MM" type="month" v-model="filter[item.model]" :transfer=true :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label" @on-change="filter[item.model]=$event" style="width: 100%;"></DatePicker>
        </FormItem>
        <FormItem :prop="item.model" :label="item.label + ':'" v-if="item.type == 'datetime'" >
          <DatePicker type="datetime" format="yyyy-MM-dd HH:mm:ss" :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label" :transfer=true v-model="filter[item.model]" @on-change="filter[item.model]=$event" style="width: 100%;"></DatePicker>
        </FormItem>
        <FormItem :label="item.label + '：'" v-if="item.type=='datetimerange'" :prop="item.model">
          <Date-picker type="datetimerange" :format="item.format || 'yyyy-MM-dd HH:mm:ss'" :placeholder="item.placeholder ? item.placeholder : '请选择' + item.label" class="selectW" v-model="filter[item.model]" @on-change="filter[item.model] = $event"></Date-picker>
        </FormItem>
        <FormItem :label="item.label + '：'" v-if="item.type=='radio'" :prop="item.key">
          <RadioGroup v-model="filter[item.model]">
            <Radio :value="option.value" v-for="option in item.options" :key="option.value">{{option.name}}</Radio>
          </RadioGroup>
        </FormItem>
        <div v-if="item.type == 'button' && !toggleBtnType && item.buttonArr.length == 1" style="float: right; text-align: right;">
          <FormItem style="margin-bottom: 5px;" label="  ">
            <div style="float: right;" v-for="(buttonItem,index) in item.buttonArr" :key="index" >
              <template v-if="buttonItem.action != 'upload' && buttonItem.action != 'reset'">
                <template v-if="buttonItem.permissions">
                  <Button style="margin: 5px 0 0 12px; width: 90%;" :type="buttonItem.type" @click="buttonItem.fun && runMethods(buttonItem.fun, buttonItem.params)">{{ buttonItem.message }}</Button>
                </template>
                <template v-else>
                  <Button style="margin: 5px 0 0 12px; width: 90%;" :type="buttonItem.type" @click="buttonItem.fun && runMethods(buttonItem.fun, buttonItem.params)">{{ buttonItem.message }}</Button>
                </template>
              </template>
              <Button :type="buttonItem.type" style="margin: 5px 0 0 5px;" v-if="buttonItem.action == 'reset'" @click="resetForm(buttonItem.fun)">{{ buttonItem.message }}</Button>
              <ExcelUpload style="margin: 5px 0 0 5px; width: 90%" :scene="buttonItem.fun" :uploadUrl="buttonItem.uploadUrl" :fileName="buttonItem.fileName" v-if="buttonItem.action == 'upload'"></ExcelUpload>
            </div>
          </FormItem>
        </div>
        <div v-if="item.type == 'button' && !toggleBtnType && item.buttonArr.length > 1">
          <FormItem style="margin-bottom: 5px;" label="  ">
            <div style="float: right;" v-for="(buttonItem,index) in item.buttonArr" :key="index" >
              <template v-if="buttonItem.action != 'upload' && buttonItem.action != 'reset'">
                <template v-if="buttonItem.permissions">
                  <CustomButton :type="buttonItem.type" style="margin: 5px 0 0 5px;" :permissionCode="buttonItem.permissions" @click="buttonItem.fun && runMethods(buttonItem.fun, buttonItem.params)">{{ buttonItem.message }}</CustomButton>
                </template>
                <template v-else>
                  <Button :type="buttonItem.type" style="margin: 5px 0 0 5px;" @click="buttonItem.fun && runMethods(buttonItem.fun, buttonItem.params)">{{ buttonItem.message }}</Button>
                </template>
              </template>
              <template v-if="buttonItem.action == 'reset'">
                <template v-if="buttonItem.permissions">
                  <CustomButton :type="buttonItem.type" style="margin: 5px 0 0 5px;" :permissionCode="buttonItem.permissions" @click="resetForm(buttonItem.fun)">{{ buttonItem.message }}</CustomButton>
                </template>
                <template v-else>
                  <Button :type="buttonItem.type" style="margin: 5px 0 0 5px;" @click="resetForm(buttonItem.fun)">{{ buttonItem.message }}</Button>
                </template>
              </template>
              <ExcelUpload style="margin: 5px 0 0 5px;" :scene="buttonItem.fun" :uploadUrl="buttonItem.uploadUrl" :fileName="buttonItem.fileName" v-if="buttonItem.action == 'upload'"></ExcelUpload>
            </div>
          </FormItem>
        </div>
      </Col>
    </Row>
  </Form>
  <div v-if="showMore" class="filterBtn">
    <a class="put-down" @click="changeStatus()">
      <Icon :type="buttonStatus?'ios-arrow-down':'ios-arrow-up'"></Icon>
      {{buttonStatus?' 展开':' 收起'}}
    </a>
  </div>
  </div>
</template>

<script>
import ExcelUpload from '../upload-file';
import cloneDeep from 'lodash/cloneDeep';

export default {
  name: 'table-filter',
  data () {
    return {
      toggleBtnType: false,
      buttonStatus: false
    };
  },
  props: {
    formItems: {
      type: Array,
      default: []
    },
    filter: {

    },
    defaultSpan: {
      type: Number,
      default: 4
    },
    showMore: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    runMethods (funName, params, value) {
      if (params || value) {
        this.$emit(funName, params, value);
      } else {
        this.$emit(funName);
      }
    },
    changeStatus: function () {
      this.buttonStatus = !this.buttonStatus;
      this.$store.commit('changeFilterStatus');
    },
    resetForm (callback) {
      this.$refs.tableFilterForm.resetFields();
      if (callback) {
        this.$nextTick(() => {
          this.runMethods(callback);
        });
      }
    },
    selectNormalChange(value, fun, params) {
      if (fun) {
        this.runMethods(fun, params, value);
      }
    }
  },
  computed: {
    filterStatus () {
      return this.$store.state.app.filterStatus;
    },
    fields () {
      const { formItems, defaultSpan, getVerifyRules } = this;
      const dataArr = cloneDeep(formItems);
      const spanNum = 24;
      const fields = []; // 多维数组
      if (dataArr.length) {
        let row = [];
        let span = 0;
        for (let i = 0; i < dataArr.length; i++) {
          dataArr[i].type = dataArr[i] ? (dataArr[i].type || 'input') : 'input'; // 类型设置
          const itemSpan = (dataArr[i].type == 'image' || dataArr[i].type == 'textarea') ? spanNum : (dataArr[i] ? (dataArr[i].span || defaultSpan) : defaultSpan); // 单个字段所占栅格数
          dataArr[i].span = itemSpan; // 补全span属性
          dataArr[i].isShow = dataArr[i] ? (dataArr[i].isShow != undefined ? dataArr[i].isShow : true) : true; // 补全isShow 属性
          if (dataArr[i].isShow) {
            const { key, label, verify } = dataArr[i];
            verify && (this.fieldsRules[key] = getVerifyRules(verify, label)); // 存在验证规则，则放到fieldsRules中
            span += itemSpan;
            row.push(dataArr[i]);
            if (span >= spanNum) {
              fields.push(row);
              span = 0;
              row = [];
            } else {
              if ((i + 1) == dataArr.length) {
                fields.push(row);
              }
            }
          }
        }
      }
      return fields;
    }
  },
  components: { ExcelUpload } // 子组件注入
};
</script>

<style scoped>
  .ivu-form-item{
    width: 100%;
    padding-left: 5px;
    padding-right: 5px;
  }
  .contentStatus{
    padding: 10px 40px;
  }
  .filterFormBox .ivu-col {
    transition: width .2s ease-in-out;
    min-height: 71px;
  }
  .filterOutBox {
    padding: 10px 0;
    margin-bottom: 10px;
    background: #fff;
  }
  .filterBtn {
    padding: 0 5px;
    margin-top: 0px;
  }
  .filterBtn a {
    display: block;
    width: 100%;
    height: 30px;
    background: #f7f8fb;
    line-height: 30px;
    text-align: center;
  }
  @media only screen and (max-width: 675px) {
    .contentStatus {
      padding: 0;
    }
    .ivu-form-item{
      padding-left: 5px;
      padding-right: 5px;
      margin-bottom: 16px;
    }
  }
  .filterOutBox .ivu-form-item{
    margin-bottom: 10px;
  }
</style>
